import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade';

const FADETIME = 700;

const useStyles = makeStyles(theme => ({
    background: {
        position: 'fixed',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
        zIndex: '1399',
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: "#ffffff"
    }
}));

export default function AppLoading(props) {

    const [ showLoader, setShowLoader ] = useState(false);
    const [ canHideLoader, setCanHideLoader ] = useState(false);

    const { loading } = props;

    const classes = useStyles();

    useEffect(() => {
        if (loading) {
            setShowLoader(true);
            setTimeout(function() {
                setCanHideLoader(true);
            }, FADETIME)
        } else {
            if (canHideLoader) {
                setShowLoader(false);
                setCanHideLoader(false);
            } else {
                setTimeout(function() {
                    setShowLoader(false);
                    setCanHideLoader(false);
                }, FADETIME)
            }
        }
    }, [loading])


    return (
        <Fade in={showLoader} timeout={{ enter: 0, exit: FADETIME}}>
            <div className={classes.background}>
                <Fade in={showLoader} timeout={{ enter: FADETIME, exit: FADETIME}}>
                    <CircularProgress size={120} color="secondary" thickness={3} disableShrink/>
                </Fade>
            </div>
        </Fade>
    )
}
